export default "__VITE_ASSET__CfrLm0BD__"